import { Typography } from '@pesto/ui/components/Typography';

export interface EntityErrorBannerProps {
  message: string;
  detail?: string;
}

export const EntityErrorBanner = ({ message, detail }: EntityErrorBannerProps) => (
  <div className="border-destructive/30 bg-destructive/10 text-destructive rounded-md border px-4 py-3">
    <Typography variant="body">{detail ? `${message} ${detail}` : message}</Typography>
  </div>
);
